import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'

import {
  EditCardNameStage,
  EditCardNameState,
} from 'hooks/useGoToEditCardNameStage/useGoToEditCardNameStage.types'

interface EditCardNameLocationState {
  EditCardNameModal?: EditCardNameState
}

export const useEditCardNameState = () => {
  const location = useLocation<EditCardNameLocationState | undefined>()

  const state = useMemo(() => {
    if (
      !location.state?.EditCardNameModal?.stage ||
      location.state.EditCardNameModal.stage !== EditCardNameStage.EditCardName
    ) {
      return null
    }

    return location.state.EditCardNameModal
  }, [location.state?.EditCardNameModal])

  return { state }
}
